/*
 * @Author: cc
 * @Date: 2019-11-25 12:52:25
 * @LastEditTime: 2020-07-30 14:15:57
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\weibo\directive\textTransferEmoji.js
 * @Description: 
 */ 
/**
 *  weiboTextTransferEmoji Module
 *
 * Description 文字转化为emoji表情
 * Author: Qian.qianchen 2018-11-6
 */
angular.module('weiboTextTransferEmojiModule', [])
    .directive('weiboTextTransferEmoji', ['$q', 'trsHttpService', function($q, trsHttpService) {
        return {
            // name: '',
            // priority: 1,
            // terminal: true,
            scope: {
                textContent: '=',
                // shrinkage:"@"
                // notAllowDragPic: "@"
            }, // {} = isolate, true = child, false/undefined = no change
            // controller: function($scope, $element, $attrs, $transclude) {},
            // require: 'ngModel', // Array = multiple requires, ? = optional, ^ = check parent elements
            restrict: 'A', // E = Element, A = Attribute, C = Class, M = Comment
            // template: '',
            replace: true,
            // transclude: true,
            // compile: function(tElement, tAttrs, function transclude(function(scope, cloneLinkingFn){ return function linking(scope, elm, attrs){}})),
            link: function($scope, iElm, iAttrs, controller) {
                initStatus();
                initData().then(function() {
                    transfer();
                });

                /**
                 * [initStatus description] 状态初始化
                 * @return {[type]} [description]
                 */
                function initStatus() {
                    $scope.status = {};
                    $scope.data = {
                        items: [],
                        textEmoji: []
                    };
                }

                /**
                 * [initData description] 数据初始化
                 * @return {[type]} [description]
                 */
                function initData() {
                    var deferred = $q.defer();
                    if ($scope.$root.weiboEmoji) {
                        $scope.data.items = $scope.$root.weiboEmoji;
                        deferred.resolve();
                    } else {
                        trsHttpService.httpServer('./editingCenter/weibo/toBeCompiled/data/sinaEmoji.json', '', 'get').then(function(data) {
                            $scope.$root.weiboEmoji = $scope.data.items = data;
                            deferred.resolve();
                        });
                    }
                    return deferred.promise;
                }

                function transfer() {
                    var emojiMap = {};
                    var content = $scope.textContent;
                    if (content == '' || angular.isUndefined(content)) {
                        return;
                    }
                    $scope.data.items.forEach(function(value, index) {
                        emojiMap[value.value] = value.url;
                    });
                    var targetArray = [];
                    content = textareaFormat(content);
                    content = content.replace(/\[\/?[^\]]*\]/g, function(a) {
                        if (emojiMap[a]) {
                            return "<img class='emoji_icon' src='" + emojiMap[a] + "'/>";
                        } else {
                            return a;
                        }
                    });
                    // content=content+"<a class='' ng-if=''></a>"
                    iElm.html(content);
                }

                /**
                 * [textaareaFormat description] 文字中空格和换行符转换
                 * @param  {[string]} content [description] 文字内容
                 * @return {[type]}         [description]
                 */
                function textareaFormat(content) {
                    return content.replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;');
                }
            }
        };
    }]);
